import { call, put } from 'redux-saga/effects';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';
import { lockedContentChanged } from 'features/layout/features/content/contentSlice';
import { SignalingSocket } from 'services/signaling';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';

export function* unlockContentSaga() {
  yield call(SignalingSocket.send, {
    event: 'unlockContent',
    data: {},
  });

  yield put(lockedContentChanged(null));

  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:multi_tabs.content_unlocked'),
  });

  yield put(notificationThunk);
}
